import * as React from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Modal from "@mui/material/Modal";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import { customersData } from "../../store/reducer/customersSlice";
import { useAppSelector } from "../../utils/hooks";
import { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import i18n from "../../i18n/config";
import useMediaQuery from '@material-ui/core/useMediaQuery';


export default function ReportModal({ open, close, orderByCustomer, row }) {
  const isMediumScreen = useMediaQuery('(min-width: 960px)');
  const { customers } = useAppSelector(customersData);
  const [customerdata, setCusotmerData] = useState([{}]);
  const { t } = useTranslation();

  useEffect(() => {
    let arr = [];
    let modalArray = orderByCustomer.map((val) => {
      let index = val.order.findIndex(
        (prod) => prod.id.toString() === row.id.toString()
      );

      if (index > -1) {
        arr.push(val);
      }
    });

    const findCustomerName = arr.map((val) => {
      let customer = customers.find(
        (el) => el.id.toString() === val.customerId.toString()
      );
      if (customer) {
        let product = val.order.find(
          (el) => el.id.toString() === row.id.toString()
        );
        let name = customer.name_english + "     " + customer.name_urdu;
        return { name, quantity: product.quantity };
      }
    });

    setCusotmerData(findCustomerName);

    const findOrderQuantity = orderByCustomer.map((id) => {
    });
  }, [row]);

  return (
    <div>
      <Modal
        open={open}
        onClose={close}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <Table
            sx={{minWidth: isMediumScreen ? '300px' : '200px'}}
            aria-label="simple table"
          >
            <TableHead>
              <Typography
                fontSize={"18px"}
                fontWeight="bold"
                align="center"
                style={{ textAlign: "center" }}
              >
                {i18n.language === "ur" ? row?.name_urdu : row?.name_english}
              </Typography>
              <TableRow>
                <TableCell align="center" width={"30%"}>
                  <Typography
                    fontSize={"15px"}
                    fontWeight="bold"
                    style={{ paddingLeft: "4rem" }}
                  >
                    {t("Number")}{/* شمار */}
                  </Typography>
                </TableCell>

                <TableCell align="center" width={"70%"}>
                  <Typography
                    fontSize={"18px"}
                    fontWeight="bold"
                    marginLeft="5rem"
                  >
                    {t("Customer")}{/* نام */}
                  </Typography>
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {customerdata &&
                customerdata.map((row, index) => {
                  return (
                    <TableRow key={index}>
                      <TableCell
                        align="center"
                        style={{ fontSize: 12, paddingLeft: "3rem" }}
                      >
                        {row.quantity}
                      </TableCell>
                      <TableCell
                        align="center"
                        style={{ fontSize: 12, paddingLeft: "2rem" }}
                      >
                        {row.name}
                      </TableCell>
                    </TableRow>
                  );
                })}
            </TableBody>
          </Table>
        </Box>
      </Modal>
    </div>
  );
}

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  maxHeight: 500,
  overflowY: "scroll",
  bgcolor: "background.paper",
  border: "1px solid #eee",
  boxShadow: 24,
};
